module.exports = __webpack_public_path__ + "img/prodpage_3.037b75ac.png";